export default "__VITE_ASSET__4a09cf45__"